import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { trimData } from '../utilities/TrimPayloadData';
import { loadingAction } from '../redux/actions/loadingAction';
import { showMessageAction } from '../redux/actions/showMessageAction';
import store from '../redux/store';

export const handlePutRequest =
    (data, url, isShowLoad = false, isShowToast = true, nextPageToLoad = '', useQueryParams = false) =>
    async (dispatch) => {
        data = await trimData(data);
        try {
            if (isShowLoad) dispatch(loadingAction(true));

            const config = {
                method: 'put',
                url: `${baseURL}${url}`,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const token = sessionStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            if (useQueryParams) {
                config.params = data;
                config.data = {};
            } else {
                config.data = data;
            }
            const response = await axios(config);
            console.log('API RESPONSE:', response);
            if (isShowToast) {
                toast.success(response?.messages);
            } 
            // else {
            //     store.dispatch(showMessageAction({ isShowModal: true, message: response?.data?.messages || 'Success', isError: false, url: nextPageToLoad }));
            // }
            if (isShowLoad) dispatch(loadingAction(false));
            return response?.data;
        } catch (error) {
            if (isShowLoad) dispatch(loadingAction(false));

            const errorData = error?.response?.data;

            const validationErrors = errorData?.errors;
            let combinedErrors = '';

            if (validationErrors && typeof validationErrors === 'object') {
                combinedErrors = Object.values(validationErrors).flat().join('\n');
            }

            const errorMessage = combinedErrors || errorData?.message || errorData?.messages || errorData?.error || 'Something went wrong !!';

            if (isShowToast) {
                store.dispatch(
                    showMessageAction({
                        isShowModal: true,
                        message: errorMessage,
                        isError: true
                    })
                );
            } else if (error?.response?.status === 500) {
                toast.warn(errorMessage);
            } else if (error?.response?.status === 400) {
                toast.warn(errorMessage);
            } else if (error?.response?.status === 401) {
                sessionStorage.removeItem('token');
                toast.warn('Unauthorized. Please login again.');
            } else {
                toast.warn(errorMessage);
            }

            return error?.response;
        }
    };
